import React, { useEffect } from "react";
import { useFraudCheck } from "utils/fraudCheckContext";
import { SectionSpinner } from "components/Spinner";

export const FraudCheck = ({ children = null, isAsync = false, onComplete }) => {
  const { fraudCheckComponent, fraudCheckComplete } = useFraudCheck();

  useEffect(() => {
    if (fraudCheckComplete === true && onComplete) {
      onComplete()
    }
  }, [fraudCheckComplete, onComplete]);

  if (isAsync) {
    return fraudCheckComponent || null;
  }

  if (fraudCheckComplete) {
    return children;
  }

  return (
    <>
      {fraudCheckComponent}
      <SectionSpinner data-testid="fraud-check-spinner" />
    </>
  );
};
